import type { ReactNode } from "react";
import { motion } from "motion/react";
import { Footer } from "@/landing/sections/Footer";
import { Header } from "@/landing/sections/Header";

type Props = {
  children: ReactNode;
  /** Localized full line, e.g. "Last updated: May 20, 2026" */
  lastUpdatedLine?: string;
  /** Override default max width (e.g. FAQ uses a wider column). */
  containerMaxWidthClass?: string;
  /** Standard pages */
  title?: string;
  /** When set, replaces the default title + last updated block (e.g. FAQ hero). */
  pageHeader?: ReactNode;
};

export function TextPageLayout({
  title,
  lastUpdatedLine,
  pageHeader,
  containerMaxWidthClass = "max-w-4xl",
  children,
}: Props) {
  return (
    <div className="min-h-screen overflow-x-hidden bg-white">
      <Header />
      <main className="overflow-x-hidden bg-gradient-to-br from-[#F7F7F5] via-white to-[#F7F7F5] pb-24 pt-28">
        <div className={`container mx-auto px-6 lg:px-12 ${containerMaxWidthClass}`}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {pageHeader ? (
              pageHeader
            ) : title ? (
              <>
                <h1 className="mb-4 text-4xl text-[#111111] lg:text-6xl">{title}</h1>
                {lastUpdatedLine ? (
                  <p className="mb-10 text-sm text-gray-500">
                    {lastUpdatedLine}
                  </p>
                ) : (
                  <div className="mb-10" aria-hidden />
                )}
              </>
            ) : null}
          </motion.div>
          <div>{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
